import {
    FETCH_HEALTH_SNAPSHOTS_FOR_DAILY_SUMMARY_START,
    FETCH_HEALTH_SNAPSHOTS_FOR_DAILY_SUMMARY_SUCCESS,
    FETCH_HEALTH_SNAPSHOTS_FOR_DAILY_SUMMARY_FAIL
} from 'actions/ActionTypes.js';

const INITIAL_STATE = {
    healthSnapshotsForDailySummary: {},
    healthSnapshotsForDailySummaryFetching: false,
    healthSnapshotsForDailySummaryFetchFail: false
};

// ======= Fetching Handlers =======
const fetchHealthSnapshotsForDailySummaryFetching = (state, action) => {
    return {
        healthSnapshotsForDailySummary: {
            ...state.healthSnapshotsForDailySummary
        },
        healthSnapshotsForDailySummaryFetching: true,
        healthSnapshotsForDailySummaryFetchFail: false
    };
};

const fetchHealthSnapshotsForDailySummarySuccess = (state, action) => {
    return {
        healthSnapshotsForDailySummary: {
            ...state.healthSnapshotsForDailySummary,
            [action.calendarDate]: action.data
        },
        healthSnapshotsForDailySummaryFetching: false,
        healthSnapshotsForDailySummaryFetchFail: false
    };
};

const fetchHealthSnapshotsForDailySummaryFail = (state, action) => {
    return {
        healthSnapshotsForDailySummary: {
            ...state.healthSnapshotsForDailySummary
        },
        healthSnapshotsForDailySummaryFetching: false,
        healthSnapshotsForDailySummaryFetchFail: true
    };
};

// ======= Selectors =======
export const getHealthSnapshotsForDailySummary = (state, calendarDate) => {
    return state.healthSnapshotsForDailySummary.healthSnapshotsForDailySummary[calendarDate]
        ? state.healthSnapshotsForDailySummary.healthSnapshotsForDailySummary[calendarDate]
        : [];
};

export const isHealthSnapshotsForDailySummaryFetching = (state) => {
    return state.healthSnapshotsForDailySummary.healthSnapshotsForDailySummaryFetching;
};

export const didHealthSnapshotsForDailySummaryFetchFail = (state) => {
    return state.healthSnapshotsForDailySummary.healthSnapshotsForDailySummaryFetchFail;
};

// ======= Handler Assignments =======
const handlers = {
    [FETCH_HEALTH_SNAPSHOTS_FOR_DAILY_SUMMARY_START]: fetchHealthSnapshotsForDailySummaryFetching,
    [FETCH_HEALTH_SNAPSHOTS_FOR_DAILY_SUMMARY_SUCCESS]: fetchHealthSnapshotsForDailySummarySuccess,
    [FETCH_HEALTH_SNAPSHOTS_FOR_DAILY_SUMMARY_FAIL]: fetchHealthSnapshotsForDailySummaryFail
};

// ======= Default Action =======
export default function healthSnapshotsForDailySummary(state = INITIAL_STATE, action = {}) {
    const handler = handlers[action.type];

    if (!handler) return state;
    return handler(state, action);
}
